import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import TagsInput from 'components/form/tagsinput'
import { cond, isEmpty, always, either, isNil, defaultTo } from 'ramda'
import withFieldError from 'components/form/with-error'

export const InstagramKeyword = ({
  input: { value, onChange, ...input },
  meta: { error, touched }
}) => (
  <div
    className={error && touched && 'has-error'}
    style={{ borderRadius: '2px' }}
  >
    <TagsInput
      inputProps={{
        placeholder: 'Enter keyword e.g. keyword',
        className: 'react-tagsinput-input input-medium',
        ...input,
        onBlur: input.onBlur.bind(input, value)
      }}
      addOnBlur
      value={value}
      onChange={onChange}
    />
  </div>
)

InstagramKeyword.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export const InstagramKeywordWithError = withFieldError(InstagramKeyword)

export const validate = cond([
  [either(isEmpty, isNil), always('Please enter a keyword')]
])

const InstagramKeywordField = ({ name }) => (
  <div>
    <Field
      name={`${name}.value`}
      component={InstagramKeywordWithError}
      validate={validate}
      format={defaultTo([])}
    />
  </div>
)

InstagramKeywordField.propTypes = {
  name: PropTypes.string
}

export default InstagramKeywordField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/instagram/keyword/index.js